import { routeConstants } from "./constants/routeConstants";

const bulkInsertRoutesRequest = (payload: any) => ({ type: routeConstants.bulkInsertRoutesRequest, payload });
const updateRoutesRequest = (payload: any) => ({ type: routeConstants.updateRoutesRequest, payload });

export const routeActions = {
    bulkInsertRoutesRequest, updateRoutesRequest
};
